/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE:  you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { __extends } from "tslib";
import { CanvasGridCellBase } from "./CanvasGridCellBase";
import { TextBlock } from "igniteui-react-core";
import { Brush } from "igniteui-react-core";
import { FontUtil } from "igniteui-react-core";
import { markType } from "igniteui-react-core";
import { intDivide } from "igniteui-react-core";
/**
 * @hidden
 */
var CanvasSummaryCell = /** @class */ /*@__PURE__*/ (function (_super) {
    __extends(CanvasSummaryCell, _super);
    function CanvasSummaryCell(a) {
        var _this = _super.call(this, a) || this;
        _this.dd = null;
        _this.di = new TextBlock();
        _this.c9 = 0;
        _this.da = 0;
        _this.c8 = 0;
        _this.c5 = null;
        _this.dc = 0;
        _this.c6 = false;
        _this.c7 = true;
        _this.db = 0;
        _this.cg(2);
        return _this;
    }
    CanvasSummaryCell.prototype.cp = function (a) {
        _super.prototype.cp.call(this, a);
        this.bg = intDivide(a, 2);
        this.c7 = true;
    };
    CanvasSummaryCell.prototype.dg = function (a) {
        this.c5 = a;
        this.c6 = true;
        this.z = true;
        this.c7 = true;
    };
    CanvasSummaryCell.prototype.de = function (a) {
        this.dd = a;
        this.di.ak = this.dd;
        this.z = true;
        this.c7 = true;
    };
    CanvasSummaryCell.prototype.df = function (a) {
        this.z = true;
        this.di.am = ((function () {
            var $ret = new Brush();
            $ret.color = a;
            return $ret;
        })());
    };
    CanvasSummaryCell.prototype.dh = function (a) {
        if (this.di.ak == null) {
            return;
        }
        if (a == null) {
            return;
        }
        if (this.c6 || (this.c5 != null && this.c5.g != this.dc)) {
            this.c6 = false;
            this.dc = this.c5.g;
            a.ac(this.c5);
            this.c8 = FontUtil.getCurrentFontHeight(this.bm, this.c5);
        }
        var b = this.bk;
        var c = this.a9;
        b -= (this.a6 + this.bb + this.a7 + this.bc);
        c -= (this.a8 + this.bd + this.a5 + this.ba);
        b = Math.max(b, 0);
        c = Math.max(c, 0);
        this.db = this.bj(this.di, this.dd, b / 2, a);
        this.c9 = this.bb + this.a6;
        this.da = this.bd + this.a8 + ((c / 2) - (this.c8 / 2));
    };
    CanvasSummaryCell.prototype.b7 = function (a) {
        if (this.di.ak != null) {
            if (this.c7) {
                this.dh(a);
                this.c7 = false;
            }
            this.di.n = this.c9;
            this.di.o = this.da;
            a.w(this.di);
        }
        _super.prototype.b7.call(this, a);
    };
    CanvasSummaryCell.prototype.get_ab = function () {
        return false;
    };
    CanvasSummaryCell.$t = markType(CanvasSummaryCell, 'CanvasSummaryCell', CanvasGridCellBase.$);
    return CanvasSummaryCell;
}(CanvasGridCellBase));
export { CanvasSummaryCell };
//# sourceMappingURL=CanvasSummaryCell.js.map
